/* eslint-disable no-undef */
import { mapWithConcurrency } from "@/lib/utils/mapWithConcurrency";

function readAllEntries(reader: FileSystemDirectoryReader): Promise<FileSystemEntry[]> {
  return new Promise((resolve, reject) => {
    const allEntries: FileSystemEntry[] = [];
    // readEntries はブラウザ実装によっては一度に最大100件程度しか返さないため、
    // 空配列が返るまで繰り返し呼び出して全件取得する。
    const readBatch = () => {
      reader.readEntries((entries) => {
        if (entries.length === 0) {
          resolve(allEntries);
          return;
        }
        allEntries.push(...entries);
        readBatch();
      }, reject);
    };
    readBatch();
  });
}

function entryToFile(entry: FileSystemFileEntry): Promise<File> {
  return new Promise((resolve, reject) => entry.file(resolve, reject));
}

async function collectFiles(entry: FileSystemEntry): Promise<File[]> {
  if (entry.isFile) {
    return [await entryToFile(entry as FileSystemFileEntry)];
  }
  if (entry.isDirectory) {
    const children = await readAllEntries((entry as FileSystemDirectoryEntry).createReader());
    const collected = await mapWithConcurrency(children, 4, (child) => collectFiles(child));
    return collected.flat();
  }
  return [];
}

/**
 * ドロップされたフォルダ（FileSystemDirectoryEntry）配下のファイルを、
 * サブフォルダの階層を無視してフラットな File 配列として再帰的に収集する。
 */
export async function readFilesFromDirectoryEntry(entry: FileSystemDirectoryEntry): Promise<File[]> {
  return collectFiles(entry);
}

/**
 * DataTransferItemList から、トップレベルの FileSystemEntry 一覧を取得する。
 */
export function getDataTransferEntries(items: DataTransferItemList): FileSystemEntry[] {
  return Array.from(items)
    .filter((item) => item.kind === "file")
    .map((item) => item.webkitGetAsEntry())
    .filter((entry): entry is FileSystemEntry => entry !== null);
}
